import { useCallback } from 'react';
import { TServerSendRequest } from 'js/hooks/socket/types';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetClientIP = () => {
    const send = useGenericSend();

    return useCallback(async () => {
        const { data: { clientIp } } = await send<TServerSendRequest, Types.IGetClientIPResponseData>({
            ID: 81405,
            description: 'IP address detection',
            responses: [81406, 81407]
        });

        return { clientIp };
    }, [send]);
};
